const CLICKABLE_SELECTOR = '.ni, .fp, .res-toggle';

function syncState(root) {
  root.querySelectorAll('.ni, .tab').forEach(element => {
    element.setAttribute('aria-selected', element.classList.contains('active') ? 'true' : 'false');
  });
  root.querySelectorAll('.fp').forEach(element => {
    element.setAttribute('aria-pressed', element.classList.contains('on') ? 'true' : 'false');
  });
  root.querySelectorAll('.filter-trigger, .month-button').forEach(element => {
    const container = element.closest('.filter-menu, .month-filter');
    element.setAttribute('aria-expanded', container?.classList.contains('open') ? 'true' : 'false');
  });
}

export function enhanceLegacyInteractions(root) {
  root.querySelectorAll(CLICKABLE_SELECTOR).forEach(element => {
    element.setAttribute('role', element.classList.contains('ni') ? 'tab' : 'button');
    element.setAttribute('tabindex', '0');
  });
  root.querySelectorAll('.nav, .tabs').forEach(element => element.setAttribute('role', 'tablist'));
  syncState(root);

  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const target = event.target.closest(CLICKABLE_SELECTOR);
    if (!target) return;
    event.preventDefault();
    target.click();
  };
  root.addEventListener('keydown', handleKeyDown);

  const observer = new MutationObserver(() => syncState(root));
  observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
  return () => { observer.disconnect(); root.removeEventListener('keydown', handleKeyDown); };
}
